// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Js_string from "../../../../../../node_modules/rescript/lib/es6/js_string.js";
import * as Belt_Float from "../../../../../../node_modules/rescript/lib/es6/belt_Float.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_format from "../../../../../../node_modules/rescript/lib/es6/caml_format.js";
import * as ErrorUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.mjs";
import * as City$PorterinFeature from "./City.mjs";
import * as CommonUtils$PorterinFeature from "../../../containers/fare-estimate-v1/utils/CommonUtils.mjs";
import * as Lib$PorterinFusionkitSentry from "../../../../../../node_modules/@porterin/fusionkit-sentry/src/Lib.mjs";
import * as CommonHelper$PorterinFeature from "./CommonHelper.mjs";
import * as FareEstimateForm$PorterinFeature from "../../lead-flow/view/component/form/FareEstimateForm.mjs";
import * as FareEstimateResultRepoIndia$PorterinFeature from "../../../containers/fare-estimate-v1/domain/repo/FareEstimateResultRepoIndia.mjs";

function getLandmarkLocation(landmark_location) {
  return Js_string.replaceByRe(/[+]/g, " ", Belt_Option.getWithDefault(landmark_location, ""));
}

function getLocationCoordinates(location_coordinates) {
  return Belt_Option.getWithDefault(Belt_Float.fromString(Belt_Option.getWithDefault(location_coordinates, "0.0")), 0.0);
}

function getFareEstimateFormParameter(queryParams) {
  var x = queryParams.geo_region_id;
  return {
          name: Belt_Option.getWithDefault(queryParams.customer_name, ""),
          mobile: Belt_Option.getWithDefault(queryParams.customer_mobile, ""),
          user_city: x !== undefined && CommonUtils$PorterinFeature.validateNumber(x) ? City$PorterinFeature.geoRegionIdToCity(Caml_format.int_of_string(x)) : undefined,
          frequency: Belt_Option.getWithDefault(queryParams.frequency, ""),
          utm_source: Belt_Option.getWithDefault(queryParams.utm_source, ""),
          utm_campaign: Belt_Option.getWithDefault(queryParams.utm_campaign, "")
        };
}

function addressFieldError(form_dirty, address_field, error_msg) {
  return {
          form_dirty: form_dirty,
          address_field: address_field,
          error_msg: error_msg
        };
}

function checkInvalidAddress(address_field, address_error_type) {
  if (address_error_type === undefined) {
    return false;
  }
  switch (address_error_type) {
    case "INVALID_DROP" :
        if (address_field) {
          return true;
        } else {
          return false;
        }
    case "INVALID_PICKUP" :
        if (address_field) {
          return false;
        } else {
          return true;
        }
    case "INVALID_PICKUP_DROP" :
        return true;
    default:
      return false;
  }
}

function getAddressFieldError(field, callback, response, address_field_error) {
  var match = address_field_error.form_dirty;
  if (response === undefined) {
    return CommonHelper$PorterinFeature.getError(field);
  }
  if (response.TAG === /* Ok */0) {
    return CommonHelper$PorterinFeature.getError(field);
  }
  var form_error = response._0;
  if (form_error.TAG === /* FareEstimateHashError */0) {
    return CommonHelper$PorterinFeature.getError(field);
  }
  if (match) {
    return CommonHelper$PorterinFeature.getError(field);
  }
  var form_error$1 = form_error._0;
  var match$1 = checkInvalidAddress(address_field_error.address_field, form_error$1.address_error_type);
  if (match$1) {
    return address_field_error.error_msg;
  } else {
    return Curry._1(callback, Belt_Option.getWithDefault(form_error$1.field_errors, FareEstimateForm$PorterinFeature.inital));
  }
}

function getCustomerExistInfo(mobile) {
  return CommonHelper$PorterinFeature.handleAPIRequestV2((function (param) {
                return FareEstimateResultRepoIndia$PorterinFeature.getCustomerExistFlag(mobile);
              }), (function (data) {
                return Promise.resolve(data);
              }), (function (error) {
                Curry._1(Lib$PorterinFusionkitSentry.React.captureMessage, ErrorUtils$Catalyst.resolveError(error));
                return Promise.resolve(undefined);
              }));
}

function getExtendedAddressFromPostal(postalAddress) {
  return {
          state: postalAddress.state,
          city: postalAddress.city,
          pincode: postalAddress.pincode,
          locality: postalAddress.locality,
          sub_locality: postalAddress.sub_locality
        };
}

export {
  getLandmarkLocation ,
  getLocationCoordinates ,
  getFareEstimateFormParameter ,
  addressFieldError ,
  checkInvalidAddress ,
  getAddressFieldError ,
  getCustomerExistInfo ,
  getExtendedAddressFromPostal ,
}
/* City-PorterinFeature Not a pure module */
